import { useContext } from "react";

import { useParams } from "react-router-dom";

import Layout from "@/common/Layout";

import ConfigContext from "../Config/configContext";
import RetoolLoader from "../Retool";
import RouteNotFound from "../RouteNotFound";

export default function CustomRoute() {
  const { configQuery } = useContext(ConfigContext);

  const { customNavigationSlug, customNavigationLinkSlug } = useParams();

  const customNavigation = configQuery?.config?.customNavigations?.find(
    (customNavigation) => customNavigation.slug === customNavigationSlug,
  );

  const customNavigationLink = customNavigation?.customNavigationLinks?.find(
    (customNavigationLink) =>
      customNavigationLink.slug === customNavigationLinkSlug,
  );

  if (!configQuery) {
    return null;
  }

  if (configQuery && !customNavigationLink) {
    return <RouteNotFound />;
  }

  return customNavigationLink.authenticatedRetoolLink ? (
    <RetoolLoader
      pageTitle={`${customNavigation.label}: ${customNavigationLink.label}`}
      useTitle
      retoolUrl={customNavigationLink.url}
    />
  ) : (
    <Layout pageTitle={customNavigation.label}>
      <div className="flex flex-grow h-full relative">
        <iframe
          src={customNavigationLink.url}
          width="100%"
          height="100%"
          className="flex flex-grow"
        />
      </div>
    </Layout>
  );
}
